import { createFileRoute } from '@tanstack/react-router';
import { CheckEditor } from '../../components/checks/CheckEditor';
import { useActiveCompanyId } from '../../stores/useCompanyStore';

export const Route = createFileRoute('/_auth/checks/$id_/edit')({
  component: EditCheckPage,
});

function EditCheckPage() {
  const { id } = Route.useParams();
  const companyId = useActiveCompanyId();

  if (!companyId) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: 32 }}>
        <p className="muted">No active company.</p>
      </div>
    );
  }

  return <CheckEditor companyId={companyId} editId={id} />;
}
